import { User } from 'types/account';

export const getFullUserName = (user: User) => {
  if (!user) return '';

  const { firstName, lastName, middleName } = user;
  const fullName = `${lastName || ''} ${firstName || ''} ${middleName || ''}`.trim();
  return fullName;
};
